import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = { class: "map width-100" }
const _hoisted_3 = { class: "map__side-container" }
const _hoisted_4 = { class: "flex-center width-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_filters = _resolveComponent("map-filters")!
  const _component_map_renderer = _resolveComponent("map-renderer")!
  const _component_empty_state = _resolveComponent("empty-state")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_map_filters, {
          ref: "mapFilters",
          filters: _ctx.filters,
          term: _ctx.term,
          "search-results": _ctx.searchResults,
          "to-show-results": _ctx.toShowResults,
          lon: _ctx.lon,
          lat: _ctx.lat,
          authors: _ctx.authors,
          "is-loading-authors": _ctx.isLoadingAuthors,
          "current-author": _ctx.mapParams?.author,
          onSelect: _ctx.updateData,
          onSearch: _ctx.search,
          onSelectSearch: _ctx.selectSearch,
          onUnselectSearch: _ctx.unselectRegion,
          onSearchPoint: _ctx.searchPoint,
          onStartTour: _ctx.startTour,
          onChangeState: _ctx.updateMapInfo,
          onShowTourStep: _ctx.showTourStep
        }, null, 8, ["filters", "term", "search-results", "to-show-results", "lon", "lat", "authors", "is-loading-authors", "current-author", "onSelect", "onSearch", "onSelectSearch", "onUnselectSearch", "onSearchPoint", "onStartTour", "onChangeState", "onShowTourStep"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.data && !_ctx.hasNoData)
          ? (_openBlock(), _createBlock(_component_map_renderer, {
              key: 0,
              ref: "mapRenderer",
              data: _ctx.data,
              filters: _ctx.filters,
              "file-id": _ctx.data?.id,
              "grid-values": _ctx.gridValues,
              "has-values": _ctx.hasValues,
              "map-info-list": _ctx.mapInfoList,
              "map-info-title": _ctx.mapInfoTitle,
              "variable-description": _ctx.variableDescription,
              "has-30arcsec": _ctx.has30arcsec,
              "shadow-root": _ctx.shadowRoot,
              onSelectRegion: _cache[0] || (_cache[0] = ($event: any) => {
						_ctx.updateTerm($event);
						_ctx.updatePoint($event);
						_ctx.onCloseFilterDrawer();
					}),
              onUnselectRegion: _ctx.resetSearchState
            }, null, 8, ["data", "filters", "file-id", "grid-values", "has-values", "map-info-list", "map-info-title", "variable-description", "has-30arcsec", "shadow-root", "onUnselectRegion"]))
          : (_ctx.hasNoData)
            ? (_openBlock(), _createBlock(_component_empty_state, {
                key: 1,
                "error-message": _ctx.errorMessage
              }, null, 8, ["error-message"]))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}